// import { GET_ALL_OWNER } from "helpers/url_helper";
import { ADD_PARTICULAR_OWNER, ADD_PARTICULAR_OWNER_FAIL, ADD_PARTICULAR_OWNER_SUCCESS, GET_ALL_OWNER, GET_ALL_OWNER_FAIL, GET_ALL_OWNER_SUCCESS, GET_PARTICULAR_OWNER, GET_PARTICULAR_OWNER_FAIL, GET_PARTICULAR_OWNER_SUCCESS, GET_TOP_SALES, GET_TOP_SALES_FAIL, GET_TOP_SALES_SUCCESS, GET_VIEW_COUNT_OWNER, GET_VIEW_COUNT_OWNER_FAIL, GET_VIEW_COUNT_OWNER_SUCCESS, LIKE_VIEW_OWNER, LIKE_VIEW_OWNER_FAIL, LIKE_VIEW_OWNER_SUCCESS, UPDATE_PARTICULAR_OWNER, UPDATE_PARTICULAR_OWNER_FAIL, UPDATE_PARTICULAR_OWNER_SUCCESS } from "./actionType";


const INIT_STATE = {
  error: "",
  loading: false,
  owner: {},
  owners: [],
  getTopSalesArray:[],
  viewCount: 0
};

const Owners = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARTICULAR_OWNER:
      return {
        ...state,
        loading: true,
      };

    case GET_PARTICULAR_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        owner: action.payload.data || {},
      };

    case GET_PARTICULAR_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case ADD_PARTICULAR_OWNER:
      return {
        ...state,
        loading: true,
      };

    case ADD_PARTICULAR_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case ADD_PARTICULAR_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case UPDATE_PARTICULAR_OWNER:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PARTICULAR_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case UPDATE_PARTICULAR_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



    case GET_ALL_OWNER:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        owners: action.payload.data || {},
      };

    case GET_ALL_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case GET_VIEW_COUNT_OWNER:
      return {
        ...state,
        loading: true,
      };

    case GET_VIEW_COUNT_OWNER_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case GET_VIEW_COUNT_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case LIKE_VIEW_OWNER:
      return {
        ...state,
        loading: true,
      };

    case LIKE_VIEW_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case LIKE_VIEW_OWNER_FAIL:
      return {
        ...state,
        loading: false,
      };


      case GET_TOP_SALES:
        return {
          ...state,
          loading: true,
        };
  
      case GET_TOP_SALES_SUCCESS:
        return {
          ...state,
          loading: false,
          getTopSalesArray: action.payload || [],
        };
  
      case GET_TOP_SALES_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
    default:
      return state;
  }
};

export default Owners;
